// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9d32ce2f","732":"51bf6648","977":"f7b2dc55"}[chunkId] + ".chunk.js";
};